import apiClient from "../api/apiClient"
import { endPoints } from "../config/endpoints";

export const userService = {
    async getDropdownAsync()
    {
         const response=await apiClient.get(endPoints.user.getProviderDropdown);
         return response.data
    }
}